export default "__VITE_ASSET__d640569c__"